import axiosInstance from "@/services/axiosInterceptor";

export async function getGuideConversations(studentId) {
  try {
    const response = await axiosInstance.get(
      `${studentId ? `guides/conversations?studentId=${studentId}` : "guides/conversations"}`
    );
    const data = response?.data;
    return data;
  } catch (error) {
    throw error;
  }
}
